<template>
    <div v-if="config.display" :style="{'width': config.width || '100%', 'display': config.inlineLabel ? 'flex' : 'block'}" class="control e-control" :class="{'display-flex': config.inlineLabel }">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else :style="{'display': config.inlineMessage ? 'flex' : 'block'}">
            <ejs-numerictextbox
                v-bind="syncfusionConfig"
                :type="'text'"
                :format="config.format || '###.##'"
                :min="min"
                :max="max"
                v-model="value"
                v-on:change="action($event, 'onchange')"
                v-on:focus="action($event, 'onfocus')"
                v-on:click="action($event, 'onclick')"
                :autocomplete="config.autocomplete || 'off'"
                :floatLabelType="config.floatLabelType || 'Auto'"
                :ref="ref"
                :created="created"
                :data-test-id="dataTestId"
                :enabled="!config.disabled"
            ></ejs-numerictextbox>
            <p v-if="config.message" :class="config.inlineMessage ? 'input-inline-info' : 'input-info'" v-html="ddStoreFilter(config.message)"></p>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {
    onchange: {
        type: 'actionfield',
        label: 'Change Action',
        itemsSource: 'actionStore.getActionOptions()',
        fields: {
            text: 'text',
            value: 'value'
        },
        default: {
            action: '',
            params: {}
        }
    }
};

export const numberComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    computed: {
        ref() {
            return this.config.ref || this.config.id;
        },
        min() {
            let min = -999999999;
            if (typeof this?.config?.min !== 'undefined') {
                min = this.config.min;
            }
            return min;
        },
        max() {
            let max = 999999999;
            if (typeof this?.config?.max !== 'undefined') {
                max = this.config.max;
            }
            return max;
        }
    },
    updated() {
        this.addKeyUpHandler();
    },
    methods: {
        addKeyUpHandler() {
            if (typeof this?.$refs?.[this.ref]?.ej2Instances?.element?.parentElement?.addEventListener === 'function') {
                this.$refs[this.ref].ej2Instances.element.parentElement.addEventListener('keyup', this.keyup, true);
            }
        },
        keyup(ev) {
            if (ev.keyCode === 13) { // enter
                if (typeof this.$parent.processAction === 'function') { // NOSONAR
                    this.$parent.processAction('trapEnter', ev);
                } else if (this.$parent.component && typeof this.$parent.component.processAction === 'function') {
                    this.$parent.component.processAction('trapEnter', ev);
                }
            }
        },
        created() {
            if (this.config && typeof this.$refs?.[this.ref]?.ej2Instances?.element.addEventListener === 'function') {
                this.addKeyUpHandler();
                this.$nextTick(() => {
                    // New wheel event listener to prevent scrolling when focused
                    this.$refs[this.ref]?.ej2Instances.element.addEventListener(
                        'wheel',
                        (event) => {
                            if (this.$refs[this.ref].ej2Instances.element === document.activeElement) {
                                event.preventDefault(); // Prevent scrolling behavior
                            }
                        },
                        { passive: false }
                    );
                });
            }
        },
    },
    components: {
        'ejs-numerictextbox': defineAsyncComponent(() => import('@common/syncfusion/numeric')),
    }
};

export default numberComponent;
</script>

<style lang="css" scoped>
    .number-input {
        margin: 30px 0;
    }
    .input-info {
        color: #2973b7;
    }
    /* Chrome, Safari, Edge, Opera */
    :deep(input::-webkit-outer-spin-button),
    :deep(input::-webkit-inner-spin-button) {
        -webkit-appearance: none;
        margin: 0;
    }
    /* Firefox */
    :deep(input[type=number]) {
        -moz-appearance: textfield;
    }

    :deep(.input-inline-info) {
        width: fit-content;
        white-space: nowrap;
        font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 13px !important;
        font-weight: 600;
        color: inherit;
        margin: 10px 0 5px 5px;
    }
</style>
